import { Configuration } from "@/guiide/ts/configuration/configuration";
import IncomeChartClass from "../response/charts/incomeChartClass";

class SeriesColour {
    public static getColour(seriesClass: IncomeChartClass): string {
        let cssVarName;

        switch (seriesClass) {
            case IncomeChartClass.AggregateExpensesWithoutTaxAsExpense:
                cssVarName = '--what-you-want-after-tax-color';
                break;
            case IncomeChartClass.Tax:
                cssVarName = '--expected-tax-color';
                break;
            case IncomeChartClass.Deficit:
                cssVarName = '--expected-shortfall-color';
                break;
            case IncomeChartClass.WhatYouCanGetAfterTax:
                cssVarName = '--what-you-can-expect-to-get-color';
                break;
            case IncomeChartClass.ConsumedTotalOtherIncome:
            case IncomeChartClass.OtherIncome:
                cssVarName = '--other-incomes-color';
                break;
            case IncomeChartClass.SavingsDisinvestments:
            case IncomeChartClass.Savings:
                cssVarName = '--savings-color';
                break;
            case IncomeChartClass.ConsumedTotalFinalSalaries:
            case IncomeChartClass.FinalSalary:
                cssVarName = '--final-salary-pensions-color';
                break;
            case IncomeChartClass.DefinedContDrawdown:
            case IncomeChartClass.DefinedContPotLessContingency:
                cssVarName = '--pensions-color';
                break;
            case IncomeChartClass.ConsumedStatePension:
                cssVarName = '--state-pension-color';
                break;
            case IncomeChartClass.DefinedContContingency:
                cssVarName = '--protected-pot-color';
                break;
            case IncomeChartClass.ConsumedTotalOtherInvestments:
                cssVarName = '--investments-color';
                break;
        }

        const color = Configuration.getCssVariableValue(cssVarName);

        return color;
    }
}

export { SeriesColour };
